// scene's main purpose is a container for camera/lights/objects

import { Scene } from 'three';

export default new Scene();


// WEBPACK FOOTER //
// ./src/scene.js